export default class OperationFilter {
    constructor(owners, statuses, types, creationDate, expirationDate, operationId) {
        this.owners = owners
        this.statuses = statuses
        this.types = types
        this.creationDate = creationDate
        this.expirationDate = expirationDate
        this.operationId = operationId
    }
}